import { useQuery } from 'data-fetching-client';
import { GET_PUBLIC_PRODUCTS_V2_QUERY } from '../../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc.dfc.new';
import { KNOWN_PRODUCT_API_NAMES } from '../constants/allProductApiNames';
export const ProductCacheWarmer = () => {
  useQuery(GET_PUBLIC_PRODUCTS_V2_QUERY, {
    variables: {
      productApiNames: KNOWN_PRODUCT_API_NAMES
    }
  });
  return null;
};